import { createFileRoute } from "@tanstack/react-router";
import { StakingPositionsPage } from "../../features/staking/pages/staking-positions-page";

export const Route = createFileRoute("/_layout/staking/positions")({
  component: StakingPositionsPage,
});
